import script from "./threeUpImageBand-V2.vue?vue&type=script&lang=js"
export * from "./threeUpImageBand-V2.vue?vue&type=script&lang=js"

import "./threeUpImageBand-V2.vue?vue&type=style&index=0&id=f939f480&lang=scss"

const __exports__ = script;

export default __exports__